// extracted by mini-css-extract-plugin
module.exports = {"container":"GhostTile_container__2mIbR","bottom":"GhostTile_bottom__38IFs"};